import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { License } from './license';
import { PrimaryTrade } from './primary-trade';
import { PrimaryTradeLicenseRequirement } from './primary-trade-license-requirement';
import { TradeLicense } from './trade-license';

export class VendorTrade extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static VendorTradeProperties: (
    | {
        property: keyof VendorTrade;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof VendorTrade;
        type: 'alias';
      }
    | {
        property: keyof VendorTrade;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'isPrimary', type: 'column', dataType: 'boolean' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'ExemptVendorId', type: 'column', dataType: 'number' },
    { property: 'PrimaryTradeId', type: 'column', dataType: 'number' },
    { property: 'otherTradeDescription', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'PrimaryTrade', model: 'PrimaryTrade', type: 'association' },
    { property: 'Licenses', model: 'License', type: 'association' },
    {
      property: 'PrimaryTradeLicenseRequirements',
      model: 'PrimaryTradeLicenseRequirement',
      type: 'association'
    },
    { property: 'TradeLicenses', model: 'TradeLicense', type: 'association' }
  ];

  static {
    VendorTrade.VendorTradeProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        VendorTrade.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        VendorTrade.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        VendorTrade.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(VendorTradeObject: Partial<VendorTrade>) {
    super();

    VendorTrade.VendorTradeProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = VendorTradeObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  isPrimary?: boolean;
  VendorId?: number;
  ExemptVendorId?: number;
  PrimaryTradeId?: number;
  otherTradeDescription?: string | null;
  createdAt?: Date;
  updatedAt?: Date;

  PrimaryTrade?: PrimaryTrade;
  Licenses?: License[];
  PrimaryTradeLicenseRequirements?: PrimaryTradeLicenseRequirement[];
  TradeLicenses?: TradeLicense[];
}
